import React from 'react';
import PropTypes from 'prop-types';

var checkboxIndeterminateIcon = function checkboxIndeterminateIcon(_ref) {
  var checked = _ref.checked,
      icon = _ref.icon,
      indeterminate = _ref.indeterminate;
  return /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    className: icon,
    focusable: "false",
    shapeRendering: "crispEdges",
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("g", {
    className: indeterminate,
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/React.createElement("rect", {
    height: "13",
    width: "13",
    x: "0.5",
    y: "0.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: checked,
    height: "2",
    strokeWidth: "0",
    width: "8",
    x: "3",
    y: "6"
  })));
};

process.env.NODE_ENV !== "production" ? checkboxIndeterminateIcon.propTypes = {
  /**
   * A class applied when checked
   */
  checked: PropTypes.string,

  /**
   * A class  for the icon
   */
  icon: PropTypes.string,

  /**
   * A class for the indeterminate dash
   */
  indeterminate: PropTypes.string
} : void 0;
export default checkboxIndeterminateIcon;